import RecentCallDTO from '@/Helpers/800/Report/RecentCall.dto';
import PaginationHelper from '@/Helpers/pagination.helper';
import DownloadHelper from '@/Helpers/Download.helper';
export default {
  data() {
    return {
      recentCallsList: [],
    };
  },
  mixins: [RecentCallDTO, PaginationHelper, DownloadHelper],
  methods: {
    getRecentCallsListHandler: function (params) {
      if (!this.load.val) {
        this.load.val = true;
      }
      if (!params?.toDate && !params?.fromDate) {
        const fromDate = new Date().toJSON().slice(0, 10)?.replaceAll('/', '-');
        params = {
          ...params,
          fromDate: `${fromDate}T00:00:00`,
        };
      }
      this.$store
        .dispatch('getRecentCallsList', params)
        .then(() => {
          if (this.$store.state.recent800CallsModule.successFlag) {
            const data = this.$store.state.recent800CallsModule.recentCallsResponse;
            this.setPagination(data);
            this.recentCallsList = this.transformRecentCallsList([...data?.items]);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.recent800CallsModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getRecentCallsListHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.recent800CallsModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getRecentCallsListHandler();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    playAudioHandler: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('listenToCallDispatch', id).then(() => {
        if (this.$store.state.callModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.file) {
            const url = window.URL.createObjectURL(new Blob([this.$store.state.callModule.file]));
            // this.recordFile = url;
            // this.player = true;
            try {
              this.$root.$refs.Home.recordFileHome = url;
              this.$root.$refs.Home.playerHome = true;
            } catch (error) {
              console.log('A Error accessing Home component:', error);
            }
          } else {
            this.snackText = 'فایل صوتی جهت پخش وجود ندارد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#FF5252';
            this.snakIcon = 'mdi-information';
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.callModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.callModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.playAudioFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    downloadAudioFileHandler: async function (id, fileName) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('downloadCallDispatch', id)
        .then(() => {
          if (this.$store.state.callModule.successFlag) {
            const audioFile = this.$store.state?.callModule?.file;
            if (audioFile) {
              this.downloadFile(audioFile, fileName);
            } else {
              this.showErrorAlert('فایل صوتی جهت پخش وجود ندارد');
            }
          } else {
            if (this.$store.state.callModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.downloadAudioFileHandler(id);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.callModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.downloadAudioFileHandler(id);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
    showError: function () {
      const error = this.$store.state.callModule.error;
      this.showErrorAlert(error);
    },
  },
};
